import { axiosInstance } from "../config/axiosInstance";
//IDOGAN;446265;06032025
export const patientDataService = {
  all: async (patientId: number) => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}/nurse/api/Patient/GetPatientInfo/${patientId}`
      );

      if (response.status === 200) {
        return response.data;
      } else {
        console.log("Patient service error!", response);
        throw new Error("Error in getPatientDatas");
      }
    } catch (error) {
      console.log("Patient service error!", error);
      throw new Error("Error in getPatientDatas");
    }
  },
};

export default patientDataService;
